import * as React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  FormControl,
  Button,
  Stack,
  InputAdornment,
  OutlinedInput,
  Box,
  Checkbox,
  ListItemIcon,
  ListItemButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useDropdownApis } from "../../../shared";
import InfiniteScroll from "react-infinite-scroll-component";
import { findProductType } from "../../../utils";

export const BundlesProductDialog = (props) => {
  const {
    onSelect,
    isSelected,
    disabled,
    onSubmit,
    isCheckIndeterminate,
    selectedItems,
    alreadyList,
  } = props;

  const {
    state: { product },
    productLoadNextPage,
    HandleFilterProducts,
  } = useDropdownApis({ isProductsList: true, isBundle: true });
  const { dataList, pagination, searchText } = product;

  return (
    <>
      <Stack
        justifyContent="space-between"
        height="100%"
        gap="8px"
        maxHeight={"calc(100% - 24px)"}
      >
        <FormControl
          size="small"
          fullWidth={true}
          sx={{
            pt: "24px",
          }}
        >
          <OutlinedInput
            placeholder="Search"
            sx={{
              height: "48px",
              ".MuiOutlinedInput-input": {
                pl: "0px !important",
              },
            }}
            size="small"
            value={searchText}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon size="large" />
              </InputAdornment>
            }
            endAdornment={
              searchText && (
                <InputAdornment
                  sx={{ cursor: "pointer" }}
                  onClick={(e) => {
                    HandleFilterProducts("search", "");
                  }}
                  position="end"
                >
                  <CloseIcon size="large" />
                </InputAdornment>
              )
            }
            fullWidth
            onChange={(e) => {
              HandleFilterProducts("search", e.target.value);
            }}
          />
        </FormControl>
        <Box
          id="scrollableDiv"
          sx={{ height: "100%", overflow: "auto" }}
          fullWidth
        >
          <InfiniteScroll
            scrollableTarget="scrollableDiv"
            dataLength={dataList?.length}
            next={productLoadNextPage}
            hasMore={pagination.hasMorePages}
            loader={
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                Loading...
              </Box>
            }
          >
            {dataList.length > 0 ? (
              <List sx={{ width: "100%", py: 0, bgcolor: "background.paper" }}>
                {dataList.map((value) => {
                  const labelId = `checkbox-list-label-${value}`;
                  return (
                    <>
                      {value.has_variant && value.variants.length === 0 ? (
                        ""
                      ) : (
                        <ListOfProduct
                          value={value}
                          labelId={labelId}
                          onSelect={onSelect}
                          isSelected={isSelected}
                          isCheckIndeterminate={isCheckIndeterminate}
                          selectedItems={selectedItems}
                          alReadyIDs={alreadyList.map((e, i) => {
                            return e;
                          })}
                        />
                      )}
                    </>
                  );
                })}
              </List>
            ) : (
              <Stack justifyContent="center" alignItems="center" height="100%">
                <Typography
                  sx={{ display: "inline" }}
                  component="span"
                  variant="caption"
                  color="text.secondary"
                  fontWeight={400}
                >
                  There is no products found
                </Typography>
              </Stack>
            )}
          </InfiniteScroll>
        </Box>
        <Button
          sx={{ height: "48px" }}
          variant="contained"
          fullWidth
          onClick={onSubmit}
          disabled={disabled}
        >
          Save
        </Button>
      </Stack>
    </>
  );
};

function ListOfProduct({
  value,
  labelId,
  onSelect,
  selectedItems,
  alReadyIDs,
}) {
  const [open, setOpen] = React.useState(false);

  const isCheckIndeterminate = (data) => {
    const subArray = data?.variants?.map((e, i) => {
      return e.id;
    });
    const commonIDs1 = selectedItems.filter((val) => subArray.includes(val));
    const commonIDs2 = alReadyIDs.filter((val) => subArray.includes(val));
    let commonIDs = commonIDs1.concat(commonIDs2);
    const notAllIDs = subArray.every((val) => commonIDs.includes(val));
    return commonIDs.length > 0 && !notAllIDs;
  };

  const isSelectedCheck = (value) => {
    if (value.has_variant) {
      const subArray = value?.variants?.map((e, i) => {
        return e.id;
      });
      const commonIDs1 = selectedItems.filter((val) => subArray.includes(val));
      const commonIDs2 = alReadyIDs.filter((val) => subArray.includes(val));
      let commonIDs = commonIDs1.concat(commonIDs2);

      return subArray.every((val) => commonIDs.includes(val));
    } else {
      return isSelected(value.id);
    }
  };
  const isSelected = (id) => {
    if (alReadyIDs.includes(id)) {
      return true;
    } else {
      return selectedItems.includes(id);
    }
  };
  const isDisabled = (value) => {
    return alReadyIDs.includes(value);
  };
  const isDisable = (value) => {
    if (value.has_variant) {
      const subArray = value?.variants?.map((e, i) => {
        return e.id;
      });
      const commonIDs1 = selectedItems.map((val) => subArray.includes(val));
      const commonIDs2 = alReadyIDs.filter((val) => subArray.includes(val));
      let commonIDs = commonIDs1.concat(commonIDs2);

      return subArray.every((val) => commonIDs.includes(val));
    } else {
      return alReadyIDs.includes(value.id);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: open ? "rgba(21, 96, 212, 0.08)" : "",
        borderRadius: "8px",
      }}
    >
      <ListItem key={value} disablePadding>
        <ListItemButton
          role={undefined}
          // onClick={handleToggle(value)}
          dense
          sx={{
            "&:hover": {
              backgroundColor: "rgba(21, 96, 212, 0.08)",
              borderRadius: "8px",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: "32px",
            }}
          >
            <Checkbox
              edge="start"
              disabled={isDisable(value)}
              checked={isSelectedCheck(value)}
              indeterminate={isCheckIndeterminate(value)}
              // tabIndex={-1}
              onChange={(e) => {
                onSelect(value, e);
                setOpen(true);
              }}
              disableRipple
              inputProps={{ "aria-labelledby": labelId }}
            />
          </ListItemIcon>
          <ListItemText
            id={labelId}
            onClick={() => setOpen(!open)}
            primary={
              <>
                {value.name}
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50px",
                    height: "18px",
                    width: "18px",
                    backgroundColor: "#1560D414",
                    color: "#1560D4",
                    fontSize: "10px",
                    marginLeft: "6px",
                  }}
                >
                  {findProductType(value.product_type)}
                </span>
              </>
            }
          />      
          {value.variants?.length > 0 && (
            <img
              src="/icons/ic_dropdown.svg"
              style={{
                transform: !open ? "rotate(180deg)" : "",
              }}
              onClick={() => setOpen(!open)}
            />
          )}
        </ListItemButton>
      </ListItem>
      {open &&
        value.variants.map((v) => {
          return (
            <ListItemButton
              role={undefined}
              dense
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(21, 96, 212, 0.08)",
                  borderRadius: "8px",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: "32px",
                  marginLeft: "12px",
                }}
              >
                <Checkbox
                  edge="start"
                  checked={isSelected(v.id)}
                  disabled={isDisabled(v.id)}
                  // tabIndex={-1}
                  onChange={() => onSelect(v)}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText primary={v.name} />
            </ListItemButton>
          );
        })}
    </Box>
  );
}
export default ListOfProduct;
